import { render, staticRenderFns } from "./dailyQuestionSix.vue?vue&type=template&id=237e6894&scoped=true"
import script from "./dailyQuestionSix.vue?vue&type=script&lang=js"
export * from "./dailyQuestionSix.vue?vue&type=script&lang=js"
import style0 from "./dailyQuestionSix.vue?vue&type=style&index=0&id=237e6894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e6894",
  null
  
)

export default component.exports